import * as actions from './actions';

import { ActionType, createReducer } from 'typesafe-actions';

import { ACTION_STATUSES } from 'shared/consts/consts';
import { ServiceContentDeeplinkState } from './types';

export const INITIAL_STATE: ServiceContentDeeplinkState = {
  deeplink: null,
  createServiceContentDeeplink: {
    status: null,
    error: null,
  },
};

const createServiceContentDeeplinkRequestHandler = (
  state: ServiceContentDeeplinkState,
): ServiceContentDeeplinkState => ({
  ...state,
  createServiceContentDeeplink: {
    error: null,
    status: ACTION_STATUSES.PENDING,
  },
});

const createServiceContentDeeplinkSuccessHandler = (
  state: ServiceContentDeeplinkState,
  { payload }: ActionType<typeof actions.createServiceContentDeeplink.success>,
): ServiceContentDeeplinkState => ({
  ...state,
  deeplink: payload,
  createServiceContentDeeplink: {
    error: null,
    status: ACTION_STATUSES.FULFILLED,
  },
});

const createServiceContentDeeplinkFailureHandler = (
  state: ServiceContentDeeplinkState,
  { payload }: ActionType<typeof actions.createServiceContentDeeplink.failure>,
): ServiceContentDeeplinkState => ({
  ...state,
  createServiceContentDeeplink: {
    error: payload.error,
    status: ACTION_STATUSES.REJECTED,
  },
});

const ServiceContentDeeplinkReducer = createReducer(INITIAL_STATE)
  .handleAction(actions.createServiceContentDeeplink.request, createServiceContentDeeplinkRequestHandler)
  .handleAction(actions.createServiceContentDeeplink.success, createServiceContentDeeplinkSuccessHandler)
  .handleAction(actions.createServiceContentDeeplink.failure, createServiceContentDeeplinkFailureHandler);

export default ServiceContentDeeplinkReducer;
